module.exports = __webpack_public_path__ + "img/vuebackground.fc0e3b60.jpg";